import React from 'react';
import {uniqueId} from 'lodash';
import {Table} from '@/web-components';
import {useTaskReportColumns} from './TaskReportUtil';
import {useIntl} from 'react-intl';

export const getBaseLevelTableHeaderTotals = (tableHeader, currency, customFieldDefinitions) => {
	const {formatMessage} = useIntl();
	const columns = useTaskReportColumns(customFieldDefinitions);

	const row = {
		name: formatMessage({id: 'common.totals'}),
		...tableHeader.totals,
		currency,
	};

	return (
		<Table.Rows data={{rows: [columns.length]}} canExpand={false} hasHeader>
			{({tableColumnsProps}) => {
				return (
					<Table.Row {...tableColumnsProps} key={uniqueId('key_')}>
						{columns.map(item => (
							<Table.Column key={'total_' + item.id}>{item.Total && <item.Total row={row} />}</Table.Column>
						))}
					</Table.Row>
				);
			}}
		</Table.Rows>
	);
};
